import parseIsoDuration from './parseIsoDuration';

const getDurationInDays = (isoDuration: string): number => {
    if (!isoDuration) {
        return 0;
    }
    const { years, months, days } = parseIsoDuration(isoDuration);
    const durationInDays = years * 365 + months * 30 + days;
    return durationInDays;
};

export default getDurationInDays;
